export const initialState = {
  searchResult: null,
  selectedResult: null,
  levels: [],
  classMates: null,
  iroExamStatus:null
};